/**
*
* useTopic
*
*/

import React from 'react';
import { get } from 'lodash-es';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import Avatar from 'components/media/Avatar/index.jsx';
import sameRole from 'utils/sameRole.js';
import ConversationIcon from './ConversationIcon.jsx';
import { CONVERSATION_TYPE_INDIVIDUAL, FILTER_PARTICIPANTS_OTHER, FILTER_PARTICIPANTS_CURRENT } from './constants.jsx';
import useFilterParticipants from './useFilterParticipants.js';

function useTopic(topic) {
  const role = useCurrentRole();
  const filterParticipants = useFilterParticipants();
  if (!topic) {
    return {};
  }
  const { loading, error, participants, topicType, latestMessage, highlightedMessage, theme } = topic;
  if (loading || error) {
    return { ready: false };
  }
  const { createdBy } = latestMessage || highlightedMessage || {};
  const wasLast = sameRole(createdBy, role);
  const otherParticipants = filterParticipants(participants, FILTER_PARTICIPANTS_OTHER);
  const currentParticipants = filterParticipants(otherParticipants, FILTER_PARTICIPANTS_CURRENT);
  function getAvatar() {
    if (theme && theme.avatar) {
      return <Avatar src={theme.avatar} />;
    }
    return currentParticipants.length === 1
      ? <Avatar src={currentParticipants[0].avatar} />
      : <ConversationIcon isPrivate={topicType === CONVERSATION_TYPE_INDIVIDUAL} color={get(topic, 'theme.color.hex')} />;
  }
  return { ready: true, avatar: getAvatar(), otherParticipants, wasLast };
}

export default useTopic;
